import { PluginContainerData, Link } from "./common";
const baseLinkPreviewData = {};
const LinkPreviewData = {
  fromJSON(object) {
    const message = { ...baseLinkPreviewData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.link = object.link !== void 0 && object.link !== null ? Link.fromJSON(object.link) : void 0;
    message.title = object.title !== void 0 && object.title !== null ? String(object.title) : void 0;
    message.thumbnailUrl = object.thumbnailUrl !== void 0 && object.thumbnailUrl !== null ? String(object.thumbnailUrl) : void 0;
    message.description = object.description !== void 0 && object.description !== null ? String(object.description) : void 0;
    message.html = object.html !== void 0 && object.html !== null ? String(object.html) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.link !== void 0 && (obj.link = message.link ? Link.toJSON(message.link) : void 0);
    message.title !== void 0 && (obj.title = message.title);
    message.thumbnailUrl !== void 0 && (obj.thumbnailUrl = message.thumbnailUrl);
    message.description !== void 0 && (obj.description = message.description);
    message.html !== void 0 && (obj.html = message.html);
    return obj;
  }
};
export {
  LinkPreviewData
};
//# sourceMappingURL=plugin_link_preview.js.map
